module.exports = __webpack_public_path__ + "static/media/mfa.4d2ce9ef.png";